import { useMemo } from 'react'

import { ModalDialog } from 'core-components/library/modalDialog'

import { DeleteDocumentDialogContent } from './DeleteDocumentDialogContent'

interface IDeleteDocumentDialogProps {
  show: boolean
  documentLabel: string
  onConfirm: () => Promise<unknown>
  onDeleted: () => void
  onError: (e: unknown) => void
  closeDialog: () => void
}

export const DeleteDocumentDialog = ({
  show,
  documentLabel,
  onConfirm,
  onDeleted,
  onError,
  closeDialog,
}: IDeleteDocumentDialogProps) => {
  const contentProps = useMemo(
    () => ({ documentLabel, onConfirm, onDeleted, onError, closeDialog }),
    [documentLabel, onConfirm, onDeleted, onError, closeDialog]
  )

  return (
    <ModalDialog
      size="xs"
      content={DeleteDocumentDialogContent}
      contentProps={contentProps}
      show={show}
      closeOnOutsideClick={false}
      onClose={closeDialog}
    />
  )
}

DeleteDocumentDialog.displayName = 'DeleteDocumentDialog'
